<template>
  <footer class="footer">
  </footer>
</template>

<script>
export default {
  name: 'FooterPage',
}
</script>
